// @ts-nocheck
/* eslint-enable */
import { createPropertyTypeReducer } from 'app/shared/utils/sitemapUtils';

const propertyTypeReducer = createPropertyTypeReducer({
  city: 'cities',
  zip: 'zip-codes',
  county: 'counties',
  neighborhood: 'neighborhoods',
});

const StateSitemap = function (sitemap = [], listings = []) {
  this.apartments = sitemap.filter((item) => item.header === 'apartments-for-rent').reduce(propertyTypeReducer, {});
  this.houses = sitemap.filter((item) => item.header === 'houses-for-rent').reduce(propertyTypeReducer, {});
  this.condos = sitemap.filter((item) => item.header === 'condos-for-rent').reduce(propertyTypeReducer, {});
  this['affordable apartments'] = sitemap
    .filter((item) => item.header === 'affordable-apartments-for-rent')
    .reduce(propertyTypeReducer, {});
  this['for rent by owner'] = sitemap
    .filter((item) => item.header === 'for-rent-by-owner')
    .reduce(propertyTypeReducer, {});
  this['rooms for rent'] = sitemap.filter((item) => item.header === 'rooms-for-rent').reduce(propertyTypeReducer, {});
  this['multi-family buildings'] = {
    'multi-family buildings': listings.map((listing) => {
      return {
        name: listing.displayName,
        uriV2: listing.uriV2,
        phrase: `Building in ${listing?.address?.city}`,
      };
    }),
  };
};

export default StateSitemap;
